import React from "react";
import Render from "../../utilities/Render";
//import secondaryNavDataLocal from "./secondary-nav.json";

function SecondaryNav(props) {
  return (
    <div>
      <strong>{props.data.title}</strong>
      {buildTree(props.data.navigation)}
    </div>
  );
}

function buildTree(data) {
  return (
    <ul>
      {data.map((item, index, arr) => {
        if (item.children.length <= 0 || item.active == false) {
          return (
            <li className={item.active ? "active" : ""} key={item.assetID}>
              <a href={item.pageURL}>{item.pageName}</a>
            </li>
          );
        } else {
          return (
            <li className={item.active ? "active" : ""} key={item.assetID}>
              <a href={item.pageURL}>{item.pageName}</a>
              {buildTree(item.children)}
            </li>
          );
        }
      })}
    </ul>
  );
}

Render.Component("#secondary-nav", secondaryNavDataCMS, SecondaryNav);

export default SecondaryNav;
